// extracted by mini-css-extract-plugin
export default {"fileUploadLabel":"RulesModal_fileUploadLabel__p6gqg"};